import { getConstant } from '../utils';

export const getLeafFieldPoints = getConstant('GET_FIELD_POINTS_LEAF');
export const calculateDiagnostics = getConstant('CALCULATE_LEAF_DIAGNOSTICS');